export default {"src":"/_next/static/media/UNISWAP.1937500c.svg","height":54,"width":46,"blurWidth":0,"blurHeight":0};